<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        Coupon: {{ payload.name }}
      </p>
    </header>

    <div class="card-content">
      <h6 class="has-text-weight-bold">
        Reedemed By:
      </h6>

      <b-table
        striped
        bordered
        paginated
        pagination-simple
        pagination-position="bottom"
       :data="tableData || []" :columns="columns">
      </b-table>
    </div>

    <footer class="modal-card-foot">
      <b-button type="is-danger" label="Close" @click="closeModal()"/>
    </footer>

  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment';
export default Vue.extend({
  props: {
    payload: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      columns: [
        {
          field: 'id',
          label: 'ID',
          width: '40',
          numeric: true
        },
        {
          field: 'uid',
          label: 'UID',
        },
        {
          field: 'email',
          label: 'Email',
        },
        {
          field: 'date',
          label: 'Redeemed Date',
          centered: true
        }
      ]
    }
  },
  computed: {
    tableData() {
      return this.payload.redemptions.map((user, index) => {
        return {
          id: index + 1,
          uid: user.userId,
          email: user.email,
          date: moment(user.date).format('DD/MM/YYYY')
        }
      })
    }
  },
  mounted() {
    // console.log('payload', this.payload);
    // console.log('tableData', this.tableData);
  },
  methods: {
    closeModal() {
      this.$parent.close()
    }
  }
})
</script>